<template>
    <BaseButton v-if="items.length === 1" theme="primary" class="body-small whitespace-nowrap flex items-center gap-2" @click="handleSelect(items[0])">
        <i class="bi bi-plus-lg icon-semibold" aria-hidden="true"></i>
        {{ items[0].label }}
    </BaseButton>
    <BaseDropdownMenu v-else :sections="sections" @select="handleSelect">
        <template #trigger>
            <BaseButton theme="primary" class="body-small whitespace-nowrap flex items-center gap-2">
                <i class="bi bi-plus-lg icon-semibold" aria-hidden="true"></i>
                Add people
                <i class="bi bi-chevron-down text-sm/none" aria-hidden="true"></i>
            </BaseButton>
        </template>
    </BaseDropdownMenu>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDropdownMenu, { type DropdownMenuItem, type DropdownMenuSection } from "~vue/components/BaseDropdownMenu.vue";
import { computed } from "vue";

type AddPeopleMenuProps = {
    calendarImportEnabled?: boolean;
    hasCalendarIntegration?: boolean;
    csvImportEnabled?: boolean;
};

const { calendarImportEnabled = false, hasCalendarIntegration = false, csvImportEnabled = false } = defineProps<AddPeopleMenuProps>();

const emit = defineEmits<(event: "calendar" | "connectCalendar" | "csv" | "manual") => void>();

type AddPeopleItem = DropdownMenuItem & { id: Parameters<typeof emit>[0] };

const items = computed<AddPeopleItem[]>(() => {
    const entries: AddPeopleItem[] = [];
    if (calendarImportEnabled) {
        entries.push(
            hasCalendarIntegration
                ? { id: "calendar", type: "button", label: "From your calendar", icon: "bi bi-calendar3" }
                : { id: "connectCalendar", type: "button", label: "Connect your calendar", icon: "bi bi-calendar3" },
        );
    }
    if (csvImportEnabled) {
        entries.push({ id: "csv", type: "button", label: "Upload a CSV", icon: "bi bi-file-earmark-arrow-up" });
    }
    entries.push({ id: "manual", type: "button", label: "Add one at a time", icon: "bi bi-person-plus" });
    return entries;
});

const sections = computed<DropdownMenuSection[]>(() => [{ id: "add-people", items: items.value }]);

const handleSelect = ({ id }: DropdownMenuItem) => emit(id as Parameters<typeof emit>[0]);
</script>
